import { bereitsBestelltZeilen, manuellPruefenZeilen } from '../lauf';
import type { Vorschau } from '../typen';

interface Props {
  vorschau: Vorschau;
}

/**
 * Hinweisboxen: Positionen, die bei einem Lieferanten schon in einem frueheren Lauf versendet wurden (mit damals
 * bestellter Menge), und Positionen mit hoeherer Menge oder unklarem frueheren Versand („manuell pruefen", CR-01).
 * Nur React-Textknoten.
 */
export default function BereitsBestellt({ vorschau }: Props) {
  const zeilen = bereitsBestelltZeilen(vorschau);
  const manuell = manuellPruefenZeilen(vorschau);
  if (zeilen.length === 0 && manuell.length === 0) return null;
  return (
    <div className="space-y-2">
      {manuell.length > 0 && (
        <div className="p-3 rounded border border-red-300 bg-red-50 text-red-800 text-sm space-y-1">
          <p className="font-semibold">
            Manuell prüfen — Menge gestiegen oder Versand unklar, nicht versendet, Auftrag bleibt in 5.2
          </p>
          <ul className="list-disc pl-5">
            {manuell.map((z) => (
              <li key={z.text}>{z.text}</li>
            ))}
          </ul>
        </div>
      )}
      {zeilen.length > 0 && (
        <div className="p-3 rounded border border-yellow-400 bg-yellow-50 text-yellow-900 text-sm space-y-1">
          <p className="font-semibold">Bereits bestellt — wird nicht erneut versendet</p>
          <ul className="list-disc pl-5">
            {zeilen.map((z) => (
              <li key={z.text}>
                {z.text}
                {z.positionen.length > 0 && (
                  <ul className="list-[circle] pl-5 text-xs">
                    {z.positionen.map((p) => (
                      <li key={p}>{p}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
